module.exports = __webpack_public_path__ + "img/practices.1128b2fc.svg";